import {createBrowserRouter, RouterProvider} from "react-router-dom";
import IndexLayout from "../layout/indexLayout";
import BeforLogin from "../layout/beforLogin";
import Chat from "../layout/chat";


const Root = () => {

    const router = createBrowserRouter([
            {
                path:'/',
                element:<IndexLayout/>,
                children:[
                    {
                        path : '/' ,
                        element:<BeforLogin/>
                    },{
                        path:'/chat',
                        element:(
                            <Chat/>
                        )
                    },
                ]
            }
    ])
    
    return(
        <RouterProvider router={router}/>
    )
}



export default Root;